import { FormattedMessage } from "react-intl";
import classNames from "classnames";

// Styles
import tableStyles from "./../../../theme/table.module.css";
import styles from "./styles.module.css";
import { Dropdown } from "react-bootstrap";

// Components
import { Settings, Payment } from "../../../interfaces";
import CustomToggle from "../../../components/CustomToggle";

// Store
import { usePaymentsStore } from "../../../store/payments";

// Config
import config from "../../../config";
const isDev = config.ENV === "staging" || config.ENV === "local";

const PaymentsTable = (props: {
  settings: Settings;
  handleClick: (payment: Payment) => void;
  onTransferFunds: (payment: Payment) => void;
  onOpenConversation: (payment: Payment) => void;
}) => {
  const { handleClick } = props;
  const payments = usePaymentsStore((state) => state.payments);

  const { tableTitle, tableValue } = tableStyles;

  return (
    <div className={`${tableStyles.tableContainer} ${styles.tableContainer}`}>
      <table className="table mb-0">
        <thead className={tableStyles.theadFixed}>
          <tr className={tableStyles.tableHeader}>
            <th className={`${tableStyles.tableTitle}  ${styles.date}`}>
              <FormattedMessage id="leads.payments.date" />
            </th>

            {props.settings.companies.length > 1 && (
              <th className={tableTitle}>
                <FormattedMessage id="common.company" />
              </th>
            )}
            <th className={tableTitle}>
              <FormattedMessage id="common.name" />
            </th>
            <th className={tableTitle}>
              <FormattedMessage id="leads.payments.amount" />
            </th>

            <th className={tableTitle}>
              <FormattedMessage id="leads.payments.bookings" />
            </th>
            <th className={tableTitle}>
              <FormattedMessage id="leads.payments.status" />
            </th>
            <th className={tableTitle}>
              <FormattedMessage id="leads.payments.status" />
            </th>
            {/* Actions column */}
            <th className={tableTitle}></th>
          </tr>
        </thead>

        <tbody className={tableStyles.tableBody}>
          {payments.length === 0 && (
            <tr className="fs-3">
              <td className="text-center" colSpan={9}>
                <FormattedMessage id="common.noResults" />
              </td>
            </tr>
          )}
          {payments.map((p: Payment) => {
            // Use a store to store payments data and transform it

            const contact = p.contact;
            return (
              <tr key={p.id} onClick={() => handleClick(p)}>
                <td className={`${styles.date} ${tableValue}`}>{p.date}</td>

                {props.settings.companies.length > 1 && (
                  <td className={tableValue}>{p.company}</td>
                )}
                <td className={tableValue}>
                  <div className="flex gap-2 align-items-center">
                    <div>
                      <span>{contact.name || contact.phoneNumber}</span>
                    </div>
                  </div>
                </td>

                <td className={tableValue}>
                  <div className="flex gap-1">{p.amount}</div>
                </td>
                <td className={tableValue}>
                  <div className="flex gap-1">
                    {p.bookings.map((b: any) => b.externalId).join(", ")}
                  </div>
                </td>

                <td className={tableValue}>
                  <div className="flex gap-1">
                    <div
                      className={classNames("badge ", {
                        "text-bg-light": ["expired", "active"].includes(
                          p.paymentStatus
                        ),
                        "text-bg-warning": p.refundStatus === "refunded",
                        "text-bg-success": p.paymentStatus === "paid",
                      })}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div className="fw-semibold-1">
                          {
                            <FormattedMessage
                              id={`leads.payments.${
                                p.refundStatus === "refunded"
                                  ? p.refundStatus
                                  : p.paymentStatus
                              }`}
                            />
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td className={tableValue}>
                  {p.paymentStatus === "paid" &&
                    p.refundStatus !== "refunded" && (
                      <div className="flex gap-1">
                        <div
                          className={classNames("badge ", {
                            "text-bg-light":
                              p.transferStatus === "pendingTransfer",
                            "text-bg-success":
                              p.transferStatus === "transfered",
                          })}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div className="fw-semibold-1">
                              {
                                <FormattedMessage
                                  id={`leads.payments.${p.transferStatus}`}
                                />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </td>
                <td className={tableValue}>
                  <Dropdown style={{ marginLeft: "12px" }}>
                    <Dropdown.Toggle
                      id="dropdown-custom-components"
                      as={CustomToggle}
                      title="options"
                    >
                      Custom toggle
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {isDev && (
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            props.onTransferFunds(p);
                            setTimeout(() => {
                              document.body.click();
                            }, 0);
                          }}
                        >
                          <FormattedMessage id="leads.payments.transferFunds" />
                        </Dropdown.Item>
                      )}

                      <Dropdown.Item
                        onClick={(e) => {
                          e.stopPropagation();
                          props.onOpenConversation(p);
                          setTimeout(() => {
                            document.body.click();
                          }, 0);
                        }}
                      >
                        <FormattedMessage id="leads.payments.viewConversation" />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsTable;
